import Styles from "./ShareType.module.css";

export const ShareType: Record<ShareOptionKey, ShareOptionValue> = {
  ADMIN: {
    color: Styles.admin,
    title: "ADMIN",
    tooltip: "ADMIN_TOOLTIP",
    value: 3,
  },
  EDIT: {
    color: Styles.edit,
    title: "EDIT",
    tooltip: "EDIT_TOOLTIP",
    value: 2,
  },
  READ: {
    color: Styles.read,
    title: "READ",
    tooltip: "READ_TOOLTIP",
    value: 1,
  },
  NO_ACCESS: {
    color: Styles.noAccess,
    title: "NO_ACCESS",
    tooltip: "NO_ACCESS_TOOLTIP",
    value: 0,
  },
  REMOVE: {
    title: "REMOVE",
    value: -1,
  },
};
